import { useState, useEffect } from 'react';
import { database } from '../Firebase/Firebase';
import { ref, get, update, set } from 'firebase/database';
import cookie from 'react-cookies';
const publicIp = require('public-ip');

export const useVisitorCount = () => {
  const [visitors, setVisitors] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if Firebase database is available
    if (!database) {
      console.log('Firebase database not available, using fallback visitor count');
      setVisitors(1000);
      setLoading(false);
      return;
    }

    let ipaddress;
    
    const fetchVisitorCount = async () => {
      try {
        // Get public IP address with timeout
        const ipPromise = publicIp.v4();
        const timeoutPromise = new Promise((_, reject) => 
          setTimeout(() => reject(new Error('IP fetch timeout')), 5000)
        );
        
        ipaddress = await Promise.race([ipPromise, timeoutPromise]);
        
        const countRef = ref(database, 'visitors');

        if (!cookie.load('visitor-count')) {
          // New visitor - increment count
          try {
            const snapshot = await get(countRef);
            let w = snapshot.val();
            const newCount = w[0].count + 1;
            setVisitors(newCount);
            cookie.save('visitor-count', newCount);
            
            await update(ref(database, 'visitors/0'), { count: newCount });
            await set(ref(database, `visitorInfo/${newCount}`), { ip: ipaddress });
            setLoading(false);
          } catch (error) {
            console.log('Failed to update visitor count:', error);
            // Set a fallback value if Firebase fails
            setVisitors(1000);
            setLoading(false);
          }
        } else {
          // Returning visitor - just fetch current count
          try {
            const snapshot = await get(countRef);
            let w = snapshot.val();
            setVisitors(w[0].count);
            if (cookie.load('visitor-count') !== w[0].count) {
              cookie.save('visitor-count', w[0].count);
            }
            setLoading(false);
          } catch (error) {
            console.log('Error fetching visitor count:', error);
            // Set a fallback value if Firebase fails
            setVisitors(1000);
            setLoading(false);
          }
        }
      } catch (error) {
        console.log('Error getting IP address or Firebase connection:', error);
        // Set fallback values if everything fails
        setVisitors(1000);
        setLoading(false);
      }
    };

    // Add a small delay to prevent immediate Firebase calls during app initialization
    const timer = setTimeout(() => {
      fetchVisitorCount();
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return { visitors, loading };
}; 